(() => {
  const applyAddonPromoBadges = () => {
    if (window.MudifyAddonPromoBadges && typeof window.MudifyAddonPromoBadges.apply === "function") {
      window.MudifyAddonPromoBadges.apply();
      return;
    }
    if (typeof window.fixApoTitles === "function") {
      window.fixApoTitles();
    }
    if (typeof window.debugGroupFix === "function") {
      window.debugGroupFix();
    }
  };
  document.addEventListener("DOMContentLoaded", () => {
    applyAddonPromoBadges();
  });
  class ProductForm extends window.HTMLElement {
    constructor() {
      var _a, _b;
      super();
      this.form = this.querySelector("form");
      this.submitButton = this.querySelector('[type="submit"]');
      this.errorMessage = this.querySelector("[data-error-message]");
      this.cart = document.querySelector("cart-drawer");
      const idInput = (_a = this.form) == null ? void 0 : _a.querySelector('input[name="id"]');
      if (idInput) idInput.disabled = false;
      if (this.cart && this.submitButton) {
        this.submitButton.setAttribute("aria-haspopup", "dialog");
      }
      (_b = this.form) == null ? void 0 : _b.addEventListener("submit", (e) => this.onSubmit(e));
    }
    getActiveVariantId() {
      var _a2, _b2, _c;
      var _a, _b;
      const fromVariantForm = Number((_a = document.querySelector("variant-form-custom")) == null ? void 0 : (_a2 = _a.currentVariant) == null ? void 0 : _a2.id);
      if (Number.isFinite(fromVariantForm) && fromVariantForm > 0) return fromVariantForm;
      const fromFormInput = Number((_b = this.form) == null ? void 0 : (_b2 = _b.querySelector('input[name="id"]')) == null ? void 0 : _b2.value);
      if (Number.isFinite(fromFormInput) && fromFormInput > 0) return fromFormInput;
      const fromLastEvent = Number((_c = window.__lastVariantChange) == null ? void 0 : _c.id);
      if (Number.isFinite(fromLastEvent) && fromLastEvent > 0) return fromLastEvent;
      return null;
    }
    getSelectedTireItems(mainQuantity = 1) {
      const source = window.TireWidgetAddon;
      if (!source || typeof source.getSelectedCartItems !== "function") return [];
      const items = source.getSelectedCartItems(mainQuantity);
      if (!Array.isArray(items) || !items.length) return [];
      return items.filter((item) => Number(item == null ? void 0 : item.id) > 0).map((item) => ({
        id: Number(item.id),
        quantity: Math.max(1, Number(item.quantity) || 1),
        properties: typeof (item == null ? void 0 : item.properties) === "object" && item.properties ? item.properties : {}
      }));
    }
    getSelectedFrontShockAssemblyItems(mainQuantity = 1) {
      const source = window.MudifyFrontShockAssembly;
      if (!source || typeof source.getSelectedItems !== "function") return [];
      const items = source.getSelectedItems({ quantity: mainQuantity });
      if (!Array.isArray(items) || !items.length) return [];
      return items.filter((item) => Number(item == null ? void 0 : item.id) > 0).map((item) => ({
        id: Number(item.id),
        quantity: Math.max(1, Number(item.quantity) || 1),
        properties: typeof (item == null ? void 0 : item.properties) === "object" && item.properties ? item.properties : {}
      }));
    }
    stripTireProperties(formData) {
      if (!formData) return;
      const tirePropPattern = /^properties\[_Tire(?:\s|$)/;
      const keysToDelete = [];
      for (const key of formData.keys()) {
        if (tirePropPattern.test(String(key))) {
          keysToDelete.push(key);
        }
      }
      keysToDelete.forEach((key) => formData.delete(key));
    }
    buildMainCartItem(formData) {
      if (!formData) return null;
      const mainId = Number(formData.get("id") || 0);
      if (!mainId) return null;
      const quantity = Math.max(1, Number(formData.get("quantity")) || 1);
      const properties = {};
      for (const [key, value] of formData.entries()) {
        const match = String(key).match(/^properties\[(.+)\]$/);
        if (!match) continue;
        const propName = match[1];
        const propValue = typeof value === "string" ? value : String(value ?? "");
        if (!propName || !propValue) continue;
        properties[propName] = propValue;
      }
      const item = {
        id: mainId,
        quantity
      };
      if (Object.keys(properties).length) {
        item.properties = properties;
      }
      const sellingPlan = formData.get("selling_plan");
      if (sellingPlan) {
        item.selling_plan = String(sellingPlan);
      }
      return item;
    }
    buildAddonSignature({ ucaItems = [], tireItems = [], addonItems = [], frontShockAssemblyItems = [] } = {}) {
      const serialize = (items, extra = null) => items.map((item) => {
        const id = Number(item == null ? void 0 : item.id) || 0;
        const quantity = Math.max(1, Number(item == null ? void 0 : item.quantity) || 1);
        const suffix = typeof extra === "function" ? extra(item) : "";
        return `${id}x${quantity}${suffix ? `:${suffix}` : ""}`;
      }).filter(Boolean).sort();
      const uca = serialize(ucaItems);
      const tires = serialize(
        tireItems,
        (item) => {
          var _a, _b;
          return String(item == null ? void 0 : ((_a = item.properties) == null ? void 0 : _a._tire_choice_id) || item == null ? void 0 : ((_b = item.properties) == null ? void 0 : _b._tire_variant_sku) || "").trim();
        }
      );
      const addons = serialize(addonItems);
      const frontShockAssembly = serialize(
        frontShockAssemblyItems,
        (item) => {
          var _a;
          return String(item == null ? void 0 : ((_a = item.properties) == null ? void 0 : _a["_FSA Group"]) || "").trim();
        }
      );
      const parts = [];
      if (uca.length) parts.push(`uca=${uca.join(",")}`);
      if (tires.length) parts.push(`tire=${tires.join(",")}`);
      if (addons.length) parts.push(`addons=${addons.join(",")}`);
      if (frontShockAssembly.length) parts.push(`fsa=${frontShockAssembly.join(",")}`);
      return parts.join("|");
    }
    applyAddonSignatureToMainItem(mainItem, context = {}) {
      if (!mainItem) return mainItem;
      const signature = this.buildAddonSignature(context);
      if (!signature) return mainItem;
      mainItem.properties = {
        ...mainItem.properties || {},
        "_Addon Signature": signature
      };
      return mainItem;
    }
    async addMainAndExtraItems(mainItem, extraItems = []) {
      const items = [mainItem, ...extraItems].filter((item) => Number(item == null ? void 0 : item.id) > 0);
      if (!items.length) return null;
      const body = { items };
      const deferCartRender = !!(this.cart && window.PackageProtection);
      if (!deferCartRender && this.cart && typeof this.cart.getSectionsToRender === "function") {
        body.sections = this.cart.getSectionsToRender().map((s) => s.id);
        body.sections_url = window.location.pathname;
      }
      const response = await fetch(window.routes.cart_add_url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-Requested-With": "XMLHttpRequest",
          ...deferCartRender ? { "X-Mudify-Deferred-Cart-Render": "1" } : {}
        },
        body: JSON.stringify(body)
      });
      let json = null;
      let rawText = "";
      try {
        json = await response.clone().json();
      } catch (_) {
        try {
          rawText = await response.text();
          json = rawText ? JSON.parse(rawText) : null;
        } catch (__) {
          json = null;
        }
      }
      if (json == null) {
        throw new Error(`Unexpected cart response (${response.status}).`);
      }
      if (!response.ok || json && json.status) {
        throw new Error((json == null ? void 0 : json.description) || (json == null ? void 0 : json.message) || `Cart add failed (${response.status})`);
      }
      return json;
    }
    getSelectedUcaItems(mainQuantity = 1) {
      const source = window.UCAAddons;
      if (!source || typeof source.getSelectedCartItems !== "function") return [];
      const items = source.getSelectedCartItems();
      if (!Array.isArray(items) || !items.length) return [];
      const qty = Math.max(1, Number(mainQuantity) || 1);
      return items.filter((item) => Number(item == null ? void 0 : item.id) > 0).map((item) => ({
        id: Number(item.id),
        quantity: Math.max(1, (Number(item.quantity) || 1) * qty),
        properties: typeof (item == null ? void 0 : item.properties) === "object" && item.properties ? item.properties : {}
      }));
    }
    async addUcaItems(items) {
      if (!Array.isArray(items) || !items.length) return true;
      try {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "X-Requested-With": "XMLHttpRequest"
          },
          body: JSON.stringify({
            items: items.map((item) => ({
              id: item.id,
              quantity: item.quantity,
              properties: item.properties || {}
            }))
          })
        });
        if (!response.ok) {
          const failText = await response.text();
          console.error("[UCA add-ons] add.js request failed:", response.status, failText);
          return false;
        }
        const contentType = response.headers.get("content-type") || "";
        if (contentType.includes("application/json")) {
          await response.json();
        }
        return true;
      } catch (err) {
        console.error("[UCA add-ons] add.js request error:", err);
        return false;
      }
    }
    reapplyAddonDisplay() {
      const run = () => {
        if (window.UCAAddons && typeof window.UCAAddons.refresh === "function") {
          window.UCAAddons.refresh(false);
        }
        if (window.MudifyAddonPriceSync && typeof window.MudifyAddonPriceSync.applyCombinedPrice === "function") {
          window.MudifyAddonPriceSync.applyCombinedPrice();
        }
      };
      run();
      [120, 420, 900].forEach((delay) => {
        window.setTimeout(run, delay);
      });
    }
    async finalizeCartAdd(json) {
      var _a, _b, _c, _d, _e, _f;
      if (!this.cart) return;
      const canRefresh = typeof this.cart.refreshCartDrawer === "function";
      let protectionState = null;
      if (window.PackageProtection) {
        protectionState = await window.PackageProtection.onCartMutation();
      }
      if (window.PackageProtection && canRefresh) {
        await this.cart.refreshCartDrawer({
          open: true,
          cart: protectionState == null ? void 0 : protectionState.cart
        });
      } else if ((json == null ? void 0 : json.sections) && typeof this.cart.renderContents === "function") {
        this.cart.renderContents(json);
      } else if (canRefresh) {
        await this.cart.refreshCartDrawer({ open: true });
      }
      if (protectionState) {
        (_b = (_a = this.cart).updateProtectionUI) == null ? void 0 : _b.call(_a, protectionState);
        (_d = (_c = this.cart).updateProtectionPrice) == null ? void 0 : _d.call(_c, protectionState);
        if (protectionState.error) {
          (_f = (_e = this.cart).setCartError) == null ? void 0 : _f.call(
            _e,
            "Item added, but package protection could not be synchronized. Please try again."
          );
        }
      }
      applyAddonPromoBadges();
      this.reapplyAddonDisplay();
    }
    onSubmit(e) {
      var _a;
      e.preventDefault();
      if (!this.form) return;
      if (((_a = this.submitButton) == null ? void 0 : _a.getAttribute("aria-disabled")) === "true") return;
      this.handleError();
      this.setLoading(true);
      const fd = new FormData(this.form);
      const activeVariantId = this.getActiveVariantId();
      if (activeVariantId) {
        fd.set("id", String(activeVariantId));
        const idInput = this.form.querySelector('input[name="id"]');
        if (idInput) {
          idInput.value = String(activeVariantId);
          idInput.setAttribute("value", String(activeVariantId));
        }
      }
      Array.from(fd.keys()).forEach((key) => {
        if (key.startsWith("uca-addon-choice-")) fd.delete(key);
      });
      const selectedUcaItems = this.getSelectedUcaItems(fd.get("quantity"));
      const quantity = Math.max(1, Number(fd.get("quantity")) || 1);
      const selectedTireItems = this.getSelectedTireItems(quantity);
      const selectedFrontShockAssemblyItems = this.getSelectedFrontShockAssemblyItems(quantity);
      this.stripTireProperties(fd);
      const selectedAddonItems = window.MudifyMoreAddons && typeof window.MudifyMoreAddons.getSelectedItems === "function" ? window.MudifyMoreAddons.getSelectedItems({
        quantity
      }) : [];
      const addonItems = Array.isArray(selectedAddonItems) ? selectedAddonItems.filter((item) => {
        const addonId = Number(item == null ? void 0 : item.id);
        const mainVariantId = Number(fd.get("id"));
        return addonId > 0 && addonId !== mainVariantId;
      }).map((item) => ({
        id: Number(item.id),
        quantity: Math.max(1, Number(item.quantity) || quantity),
        properties: typeof (item == null ? void 0 : item.properties) === "object" && item.properties ? item.properties : {}
      })) : [];
      const extraItems = [...addonItems, ...selectedTireItems, ...selectedUcaItems, ...selectedFrontShockAssemblyItems];
      if (!this.cart && !extraItems.length) {
        this.form.submit();
        this.setLoading(false);
        return;
      }
      if (extraItems.length) {
        const mainItem = this.applyAddonSignatureToMainItem(this.buildMainCartItem(fd), {
          ucaItems: selectedUcaItems,
          tireItems: selectedTireItems,
          addonItems,
          frontShockAssemblyItems: selectedFrontShockAssemblyItems
        });
        if (!mainItem) {
          this.setLoading(false);
          this.handleError("Could not determine selected variant.");
          return;
        }
        this.addMainAndExtraItems(mainItem, extraItems).then(async (json) => {
          this.error = false;
          if (!this.cart) {
            window.location.href = "/cart";
            return;
          }
          await this.finalizeCartAdd(json);
        }).catch((err) => {
          console.error(err);
          this.handleError(err.message || "Something went wrong");
        }).finally(() => {
          this.setLoading(false);
        });
        return;
      }
      if (!this.cart) {
        const mainItem = this.buildMainCartItem(fd);
        if (!mainItem) {
          this.setLoading(false);
          this.handleError("Could not determine selected variant.");
          return;
        }
        this.addMainAndExtraItems(mainItem).then(async () => {
          this.error = false;
          window.location.href = "/cart";
        }).catch((err) => {
          console.error(err);
          this.handleError(err.message || "Something went wrong");
        }).finally(() => {
          this.setLoading(false);
        });
        return;
      }
      let requestBody;
      const deferCartRender = !!window.PackageProtection;
      const requestHeaders = {
        "X-Requested-With": "XMLHttpRequest",
        "Accept": "application/json",
        ...deferCartRender ? { "X-Mudify-Deferred-Cart-Render": "1" } : {}
      };
      if (!deferCartRender) {
        const sectionIds = this.cart.getSectionsToRender().map((s) => s.id);
        fd.append("sections", sectionIds);
        fd.append("sections_url", window.location.pathname);
      }
      requestBody = fd;
      fetch(window.routes.cart_add_url, {
        method: "POST",
        headers: requestHeaders,
        body: requestBody
      }).then((res) => res.json()).then(async (json) => {
        if (json.status) {
          this.handleError(json.message);
          this.error = true;
          return;
        }
        this.error = false;
        await this.finalizeCartAdd(json);
      }).catch((err) => {
        console.error(err);
        this.handleError(err.message || "Something went wrong");
      }).finally(() => {
        this.setLoading(false);
      });
    }
    setLoading(state) {
      if (!this.submitButton) return;
      this.submitButton.setAttribute("aria-disabled", state ? "true" : "false");
      this.submitButton.classList.toggle("loading", state);
    }
    handleError(message = "") {
      if (!this.errorMessage) return;
      this.errorMessage.hidden = !message;
      this.errorMessage.textContent = message;
    }
  }
  if (!window.customElements.get("product-form")) {
    window.customElements.define("product-form", ProductForm);
  }
})();
